// extracted by mini-css-extract-plugin
export var checkbox = "_8m-0";
export var circle = "_8m-3";
export var horizontalContainer = "_8m-7";
export var sm = "_8m-5";
export var switch0 = "_8m-2";
export var switchDisabled = "_8m-8";
export var switchEnabled = "_8m-1";
export var textSwitchContainer = "_8m-9";
export var textSwitchOption = "_8m-a";
export var textSwitchOptionSelected = "_8m-b";
export var verticalContainer = "_8m-6";
export var xs = "_8m-4";